import Cookies from 'js-cookie';
import z from 'zod';

import { CallbackRequestBodyBodyOneSaasCheckoutType } from '@/modules/api/codegen';

const SAAS_PRICING_PLAN_COOKIE_NAME = 'passwd_saas_plan';

const saasPricingPlanCookieSchema = z.nativeEnum(CallbackRequestBodyBodyOneSaasCheckoutType);

export const getSaasCheckoutTypeCookie = () => {
    const cookieValue = Cookies.get(SAAS_PRICING_PLAN_COOKIE_NAME);

    const result = saasPricingPlanCookieSchema.safeParse(cookieValue);

    if (!result.success) {
        return;
    }

    return result.data;
};
